export function dollarsToCents(dollars: number): number {
  return Math.round(dollars * 100);
}
